import poliFoundationRequest from 'src/utils/poliFoundationRequest';

export enum TriggerType {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  RESTORED = 'restored',

  CLICKED = 'clicked',
  VIEWED = 'viewed',
  OPENED = 'opened',
  CLOSED = 'closed',
  TOGGLED = 'toggled',

  SUBMITTED = 'submitted',
  FOCUSED = 'focused',
  BLURRED = 'blurred',
  SELECTED = 'selected',
  DESELECTED = 'deselected',

  SEARCHED = 'searched',
  FILTERED = 'filtered',
  SORTED = 'sorted',

  LOGGED_IN = 'logged_in',
  LOGGED_OUT = 'logged_out',

  DOWNLOADED = 'downloaded',
  UPLOADED = 'uploaded',
}

export interface TriggerPayload {
  entity_id: string;
  entity_type: string;
  type: TriggerType;
  origin?: string;
  payload?: Record<string, any>;
}

export const sendTrigger = async ({
  entity_id,
  entity_type,
  type,
  origin = 'foundation-spa',
  payload = {},
}: TriggerPayload): Promise<void> => {
  const isDev = process.env.NODE_ENV === 'development';

  try {
    await poliFoundationRequest.post('/logs/behavior', {
      entity_id,
      entity_type,
      type,
      origin,
      payload,
    });
  } catch (error) {
    if (isDev) {
      console.error('[TriggerService] Failed to send trigger:', error);
    }
  }
};